<template>
  <div class="order">
    <div class="flex gap-5 justify-between items-center mb-6 mdmax:flex-col">
      <div class="w-3/5 flex gap-5 justify-between mdmax:w-full mdmax:flex-col">
        <div class="flex-1">
          <label class="text-base text-neutral-700 font-medium mb-1 block">Logistik</label>
          <select @change="refetch()" v-model="selectedDeliveryService" class="w-full pl-2 rounded-lg border-neutral-300 border outline-none text-sm text-neutral-500">
            <option value="" selected="selected">Semua</option>
            <option v-for="(item, index) in deliveryServices" :value="item.id" :key="'item' + index">{{ item.name }}</option>
          </select>
          <!-- <CustomSelect :options="deliveryServices" v-model="selectedDeliveryService" placeholder="Semua" optionLabel="name" /> -->
        </div>
        <div class="flex-1">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Cari nomor awb" v-model="keyword" @enter="doSearch()" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="" v-if="filteredData && filteredData.length > 0">
        <div v-for="order in filteredData" :key="order.id">
          <OrderCard :data="order" insufficientPayment />
        </div>
      </div>
      <div class="py-10 text-center" v-else>
        Data tidak ditemukan!
      </div>
    </div>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile && filteredData && filteredData.length > 0">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const NOW = new Date()
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Search: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Search'),
    // Calendar: () => import(/* webpackChunkName: "Forms" */ '@/components/Icons/Calendar'),
    OrderCard: () => import(/* webpackChunkName: "card" */ '@/components/OrderCard/OrderCard'),
    // LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    typeList: ['Semua', 'Pickup', 'Pengiriman'],
    statusList: ['Semua', 'Pickup', 'Diproses', 'Selesai', 'Komplain'],
    selectedType: '',
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 7),
      endDate: NOW
    },
    tabList: [
      {
        title: 'Semua',
        active: true
      },
      {
        title: 'Pickup',
        active: false
      },
      {
        title: 'Diproses',
        active: false
      },
      {
        title: 'Selesai',
        active: false
      },
      {
        title: 'Komplain',
        active: false
      }
    ],
    selectedTab: '',
    searchTerm: '',
    keyword: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    selectedDeliveryService: ''
  }),
  computed: {
    ...mapGetters('order', ['insufficientPayment']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('partner', ['deliveryServices']),
    filteredData() {
      let temp = this.insufficientPayment || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.getLogisticList()
    this.selectTab(this.tabList[0])
    if (!this.$route.query.page) {
      this.$router.push({ path: '/order/insufficient-payment', query: { page: 1, deliveryService: '' } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.selectedDeliveryService = this.$route.query.deliveryService
      this.getInsufficientPaymentList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.selectedDeliveryService = val.query.deliveryService
        this.getInsufficientPaymentList()
      } else {
        this.$router.push({ path: '/order/insufficient-payment', query: { page: 1, deliveryService: '' } })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions('order', ['getOrders', 'getInsufficientPayment']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('partner', ['getDeliveryServices']),
    refetch() {
      this.$router.push({ path: '/order/insufficient-payment', query: { page: parseInt(this.$route.query.page), deliveryService: this.selectedDeliveryService } })
    },
    getLogisticList() {
      this.getDeliveryServices()
    },
    selectTab(tab) {
      this.tabList.forEach(item => (item.active = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    goToDetail(target) {
      this.$router.push(`/order/insufficient-payment/${target}`)
    },
    doSearch() {
      this.searchTerm = this.keyword
      this.getInsufficientPaymentList(this.searchTerm)
    },
    showMore(page) {
      this.page = page
      this.currentPage = page
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/order/insufficient-payment', query: { page: page, deliveryService: this.$route.query.deliveryService } })
    },
    getInsufficientPaymentList(searchTerm = '') {
      this.showLoading()
      this.getInsufficientPayment({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          order_type: 'DELPKG',
          status: 'ALL',
          sort: 'DESC',
          delivery_service_id: this.selectedDeliveryService
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('error', error.response)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
  &::v-deep .vue-daterange-picker {
    display: block;
  }
}
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
select {
  height: 50px;
}
</style>
